import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  moveFolder(request: Boundaries["moveFolder"]["request"]): void;
}

function useMoveFolder(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isMoveFolderRequestPending),
    isRequestSuccess: useSelector(selector.isMoveFolderRequestSuccess),
    isRequestFailure: useSelector(selector.isMoveFolderRequestFailure),
    moveFolder: core.moveFolder,
  };
}

export { useMoveFolder };
